import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'IW',
    name: 'Zgorzelec',
    id: 'Necroswarm',
    health: 70,
    difficulty: 7,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
